export enum EIncentiveType {
  RBI = 'RBI',
  UBI = 'UBI',
}

export enum EPcgIncentiveType {
  RBI = 'RBI',
  UBI = 'UBI',
  RUBI = 'RUBI',
}

export enum EPeriodStatus {
  Active = 'Active',
  TA = 'TA',
  PaidLOA = 'Paid',
  UnpaidLOA = 'Unpaid',
}

export enum EServiceName {
  COMPLIANCE = 'Compliance',
  CONPAR = 'ConPar',
  EARNINGS = 'Earnings',
  NOTIFICATION = 'Notification',
  PERFORMANCE = 'Performance',
}
